module.exports = __webpack_public_path__ + "static/img/theme_06.f297dc5d.png";